import { render, staticRenderFns } from "./SignUp.htm?vue&type=template&id=86a92834&scoped=true&"
import script from "./SignUp.ts?vue&type=script&lang=js&"
export * from "./SignUp.ts?vue&type=script&lang=js&"
import style0 from "./SignUp.scss?vue&type=style&index=0&id=86a92834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a92834",
  null
  
)

export default component.exports